

import { Component, Mixins } from "vue-property-decorator";
import Flag from "@/components/Flags/Flag.vue";
import IbDropdown from "@/components/Dropdown/Dropdown.vue";
import { Getter } from "vuex-class";
import { LANG_MODULE_NAME } from "@/store/modules/lang";
import { TLang } from "@/models/modules/lang/interface";
import I18nToSelectItems from "@/mixins/i18n-to-select-items";
import { IListItem } from "@/models/core/core";
import langMethods from "@/models/modules/lang"
import { langEntity } from "@/models/modules/lang/entity";
import ContactInfoFormatter from "@/mixins/contact/ContactInfoFormatter";

@Component({
	components: {
		IbDropdown,
		Flag
	}
})
export default class HeaderAuth extends Mixins(
	I18nToSelectItems,
	ContactInfoFormatter,
) {

	langs: IListItem[] =[]

	public isDropdown: boolean;

	constructor() {
		super();

		this.isDropdown = false
	}

	get iconFlag() {
		let flag = this.langs.filter(i => i.key === langEntity.lang)
		return flag[0].val.flag
	}

	get inputText() {
		let text = this.langs.filter(i => i.key === langEntity.lang)
		return text[0].val.title
	}

	@Getter('lang', {namespace: LANG_MODULE_NAME})
	lang!: TLang

	created() {
		this.setSelectItems('langs', 'langs')
	}

	dropdownOpen() {
		if (this.langs) {
			window.addEventListener("click", (e: Event) => {
				if (e.target != this.$refs["btn"]) {
					this.isDropdown = false
				}
			});
		}
		this.isDropdown = !this.isDropdown
	}

	dropdownChange(key: TLang) {
		langMethods.setLang(key)
		this.isDropdown = false
	}
}

